import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const BrandHeader = () => {
  const navRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      navRef.current,
      { y: -20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power3.out", delay: 1.0 }
    );
  }, []);

  return (
    <nav
      ref={navRef}
      className="fixed top-0 left-0 w-full z-50 flex items-center justify-between px-6 md:px-10 py-5 md:py-7 opacity-0"
    >
      <a
        href="/"
        className="font-orbit font-bold text-[10px] md:text-xs tracking-[0.25em] uppercase text-brand-cream select-none leading-[1.6]"
        data-hover
      >
        ORBITAL
        <br />
        WORKS
        <span className="text-brand-accent">.</span>
      </a>

      <a
        href="mailto:hello@orbitalworks.net"
        className="group flex items-center gap-2"
        data-hover
      >
        <span className="font-sans text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase text-white/30 group-hover:text-brand-cream transition-colors duration-300">
          Contact
        </span>
        <span className="block w-2 h-2 rounded-full bg-brand-accent/40 group-hover:bg-brand-accent group-hover:shadow-[0_0_12px_rgba(226,69,39,0.6)] transition-all duration-300" />
      </a>
    </nav>
  );
};

export default BrandHeader;